"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiSelectWithForm = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/* istanbul ignore file */

const MultiSelectWithForm = props => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "multiselect--form"
  }, /*#__PURE__*/_react.default.cloneElement(props.children, {
    ...props
  }));
};
exports.MultiSelectWithForm = MultiSelectWithForm;
MultiSelectWithForm.propTypes = {
  MultiSelectWithForm: _propTypes.default.shape()
};